export const FormTemplatesByImportType = new Map<string, any>([]);
